import React, { Component } from 'react';
import { Icon } from '@mgc/react-components';
import BaseLayout from './BaseLayout';
import strings from '../strings';

export default class UnknownUser extends Component {
    render() {
        return (
            <BaseLayout>
                <div className="card m-t">
                    <div className="card-block">
                        <h2 className="card-title">
                            <span className="text-warning">
                                <Icon name="icon-warning" />
                            </span>{' '}
                            {strings.noUserRecord}
                        </h2>
                        <p className="text-description m-b-sm">
                            {strings.noUserRecordExplanation}
                        </p>
                    </div>
                </div>
            </BaseLayout>
        );
    }
}



// WEBPACK FOOTER //
// ./app/views/UnknownUser.jsx